export default __webpack_public_path__ + "static/media/taxFreeDispatches.ebb29ffe.jpg";